export default __webpack_public_path__ + "static/media/websafe365-scan-qr.c6726037.png";